import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api/bwm',
  headers: { 'x-api-key': process.env.REACT_APP_API_KEY || '' },
});

const authHeader = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const getClients = (token) =>
  api.get('/clients', token ? authHeader(token) : {}).then((r) => r.data);

export const getClient = (token, id) =>
  api.get(`/clients/${id}`, authHeader(token)).then((r) => r.data);

export const createClient = (token, payload) =>
  api.post('/clients', payload, authHeader(token)).then((r) => r.data);

export const updateClient = (token, id, payload) =>
  api.put(`/clients/${id}`, payload, authHeader(token)).then((r) => r.data);

export const deleteClient = (token, id) =>
  api.delete(`/clients/${id}`, authHeader(token)).then((r) => r.data);
